import * as Yup from 'yup'
import { validateURL } from './validators'

const SKETCH_PROFILE_URL_PREFIX = 'sketch.com/profile/'

export const initialValues = {
  shortUrlName: '',
  description: '',
  websiteUrl: '',
  shares: [],

  selectAll: false,
  checkProfileURLLoading: false,
}

export const validationSchema = Yup.object().shape({
  shortUrlName: Yup.string()
    .trim()
    .required("URL can't be blank")
    .test('url-validation', 'Invalid URL', function (value) {
      if (!value) return false // URL is required, don't allow empty
      const validationResult = validateURL(
        `https://${SKETCH_PROFILE_URL_PREFIX}${value}`
      )
      return validationResult === 'VALID'
    }),
  description: Yup.string()
    .trim()
    .max(255, 'Description must be 255 characters or less'),
  websiteUrl: Yup.string()
    .trim()
    .test('url-validation', function (value) {
      if (!value) return true // Allow empty URLs

      const validationResult = validateURL(value)
      if (validationResult === 'VALID') return true

      switch (validationResult) {
        case 'MISSING_PROTOCOL': {
          return this.createError({
            message: 'URL scheme must be http or https',
          })
        }
        default: {
          return this.createError({ message: 'Invalid URL' })
        }
      }
    }),
})
